module.exports = __webpack_public_path__ + "img/jiuzhang-back-one@2x.38eb0373.jpg";